import TextFieldControl from "components/form/TextFieldControl";
import { UseFormGetValues, UseFormReturn } from "react-hook-form";
import { Examination_Type } from "@generated/graphql";
import TestingLink from "components/TestingLink";
import useIsCreate from "hooks/useIsCreate";
import { GroupAndOpenInfoInputs } from "../types";
import CompetencyMapControl from "../../components/CompetencyMapControl";
import { CompetencyMapOptionList } from "../../types";

interface GroupAndOpenRightProps {
  form: UseFormReturn<GroupAndOpenInfoInputs>;
  examinationType: Examination_Type | undefined;
  competencyMaps: CompetencyMapOptionList;
  competencyMapsLoading: boolean;
}

const GroupAndOpenRight = ({
  form,
  examinationType,
  competencyMaps,
  competencyMapsLoading,
}: GroupAndOpenRightProps) => {
  const isCreate = useIsCreate();
  const getValues = form.getValues as unknown as UseFormGetValues<GroupAndOpenInfoInputs>;

  const showTestingLink = examinationType === Examination_Type.Open || examinationType === Examination_Type.Public;

  return (
    <>
      <CompetencyMapControl
        competencyMaps={competencyMaps}
        isEditing={isCreate}
        competencyMapsLoading={competencyMapsLoading}
      />
      <TextFieldControl
        name='competencyMapComment'
        label='Комментарий к карте компетенций'
        minRows={7}
        multiline
        disabled
      />
      <TextFieldControl
        name='competencyMapGrades'
        label='Грейд карты компетенций'
        disabled
      />
      {showTestingLink && <TestingLink link={getValues("link")} />}
    </>
  );
};

export default GroupAndOpenRight;
